import * as React from 'react';

export const getReactVersion = () => React.version;
